import { createSelector } from 'reselect';
import {
  getMyContestLaoding,
  getVersions,
  getVersionsLoading,
} from '../../../myArmyList/common/selector';
import { ContestNewView } from './view/ContestNewView';
import { VersionView } from '@Selectors/common/view/VersionView';
import { ContestParticipationView } from './view/ContestParticipationView';
import { ContestParticipationMode } from '@Models';

export const ContestNewPresenter = createSelector(
  [getVersions, getVersionsLoading, getMyContestLaoding],
  (versions, versionsIsLoading, ContestIsLoading): ContestNewView => {
    return new ContestNewView({
      versions: versions.map(
        (item) =>
          new VersionView({ id: item.id, name: item.name, game: item.game }),
      ),
      participations: new Array<ContestParticipationView>(
        new ContestParticipationView({
          id: ContestParticipationMode.INDIVIDUAL,
          name: 'individual',
        }),
        new ContestParticipationView({
          id: ContestParticipationMode.TEAM,
          name: 'team',
        }),
      ),
      isLoading: versionsIsLoading || ContestIsLoading,
      canSubmit: !versionsIsLoading && !ContestIsLoading,
    });
  },
);
